//var service_url = 'http://192.168.0.13:8090/ds/';
//var service_url = {{ config('app.url', 'https://aisup.ru') }};
//var service_url = 'http://127.0.0.1:8000';
let token = '';
const {axios} = require('./axios-init')

document.addEventListener('DOMContentLoaded', function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    token = $('meta[name="csrf-token"]').attr('content');
})

export function post_service(method, data, response, asyncType, path) {
    //id_cat_select = id_cat_select === undefined ? false : id_cat_select;
    path = path === undefined ? 'Service' : path;
    asyncType = asyncType === undefined ? true : asyncType;
    let a = $.ajax( {
        url: '/'+path+'/' + method,
        type: 'post',
        dataType: 'json',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: data,
        success: response,
        async: asyncType
    });
    a.fail(function (jqXHR, textStatus) {
        console.log(textStatus);
    })
}

export function get_service(method, data, response) {
    $.ajax( {
        url: '/Service/' + method,
        type: 'get',
        dataType: 'json',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: data,
        success: response
    });
}

export function setCookie(key, value, hour) {
    hour = hour === undefined ? false : hour;
    let expires = new Date();
    expires.setTime(expires.getTime() + ((hour ? hour : 24) * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
}

export function getCookie(key) {
    let keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}

export function moneyFormat(money){
    return new Intl.NumberFormat("ru").format(+money.toString().replace(/,/g, '.'));
}

export function requestToServer(method, data){
    return axios.post(method, data);
}

export function getFromServer(method){
    return axios.get(method);
}

export function sendToServer(method, data, callBack){
    let result = requestToServer(method, data);
    result.then(function(response){
        callBack(response.data);
    }).catch((error)=>{
        console.log(error);
    });
}

export function getNotifyPermission(){
    if (Notification.permission !== 'granted'){
        Notification.requestPermission().then(result=>{
            console.log(result)
        })
    }
}

export function sendNotify(theme, body, data = false, tag = false){
    if (window.Notification && Notification.permission === 'granted'){
        return new Notification(theme, {body: body, dir: 'auto', icon: 'favicon.ico', tag: tag, data: data})
    }
}

// функция разряжения выполнения другой функции
export function throttle(func, ms){
    let isThrottled = false;
    let saveArgs;
    let saveThis;

    function wrapper(){
        if (isThrottled){
            saveArgs = arguments;
            saveThis = this;
            return
        }
        func.apply(this, arguments)
        isThrottled = true;
        setTimeout(()=>{
            isThrottled = false;
            if (saveArgs){
                wrapper.apply(saveThis, saveArgs)
                saveArgs = saveThis = null;
            }
        }, ms)
    }
    return wrapper;
}

// функция разряжения выполнения другой функции
// без последнего выполнения
// и добивилась возможность блокировать кнопку
export function throttleNew(func, ms, disabledSelf = false){
    let isThrottled = false;

    function wrapper(){
        if (isThrottled){
            return
        }
        if (disabledSelf){
            this.disabled = true;
        }
        func.apply(this, arguments)
        isThrottled = true;
        setTimeout(()=>{
            isThrottled = false;
            this.disabled = false;
        }, ms)
    }
    return wrapper;
}

// функция задержки выполнения другой функции
export function debounce(fn, ms){
    let handleTimer;
    return function(){
        const fnCall = ()=>{fn.apply(this, arguments)}
        clearTimeout(handleTimer);
        handleTimer =  setTimeout(fnCall, ms)
    }
}

function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log('Fallback: Copying text command was ' + msg);
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
}
export function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(function() {
    console.log('Async: Copying to clipboard was successful!');
  }, function(err) {
    console.error('Async: Could not copy text: ', err);
  });
}
